import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useFetch from "hooks/useFetch";
import * as XLSX from "xlsx";
import { useTranslation } from "react-i18next";

const GenerateExcelForUserConnexions = () => {
  const { userId } = useParams();
  const { get } = useFetch();
  const [userConnexions, setUserConnexions] = useState([]);
  const [loading, setLoading] = useState(true);
  const params = new URLSearchParams(location.search);
  const firstName = params.get("firstName");
  const lastName = params.get("lastName");
  const { t } = useTranslation("admin");

  const getUserConnexions = async () => {
    try {
      const userConnexions = await get(
        `/admin/users/${userId}/user_connexions`
      );

      if (userConnexions) {
        setUserConnexions(userConnexions);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const generateExcel = () => {
    const summaryRows = [
      ["Champ", "Valeur"],
      ["Nom de l'apprenant", `${firstName} ${lastName}`],
      ["Identifiant utilisateur", userId],
      ["Nombre total de connexions", userConnexions.length],
      [
        "Première connexion",
        formatDate(userConnexions[userConnexions.length - 1]?.created_at),
      ],
      ["Dernière connexion", formatDate(userConnexions[0]?.created_at)],
      ["Date de génération du rapport", formatDate(new Date())],
    ];

    const summarySheet = XLSX.utils.aoa_to_sheet(summaryRows);

    const historyRows = userConnexions.map((connexion, index) => ({
      "N°": index + 1,
      "Nom et prénom": `${firstName} ${lastName}`,
      "Date et heure de connexion": formatDate(connexion.created_at),
    }));

    const historySheet = XLSX.utils.json_to_sheet(historyRows);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, summarySheet, "Synthèse");

    XLSX.utils.book_append_sheet(workbook, historySheet, "Historique");

    XLSX.writeFile(workbook, `Releve_connexions_${firstName}_${lastName}.xlsx`);
  };

  useEffect(() => {
    getUserConnexions();
  }, []);

  useEffect(() => {
    userConnexions.length && console.log(userConnexions, "userConnexions");
  }, [userConnexions]);

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border text-warning" />
        <p className="mt-3">Chargement des connexions...</p>
      </div>
    );
  }

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="card shadow-sm border-0">
            <div className="card-body p-5">
              <h1 className="h3 mb-3">{t("generation_of_connexions_list")} </h1>

              <p className="text-muted mb-4">{t("generation_explanation")}</p>

              <div className="bg-light rounded p-4 mb-4">
                <div className="row">
                  <div className="col-md-6 mb-3 mb-md-0">
                    <div className="text-muted small">{t("learner")}</div>
                    <div className="fw-bold">
                      {firstName} {lastName}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="text-muted small">{t("number_of_connexions")} </div>
                    <div className="fw-bold">{userConnexions.length}</div>
                  </div>
                </div>
              </div>

              <div className="alert alert-info mb-4">
                <strong>{t("the_generated_file_will_contain")} :</strong>
                <ul className="mb-0 mt-2">
                  <li>{t("a_summary_sheet")}</li>
                  <li>{t("the_complete_history")} </li>
                  <li>{t("the_generation_date")}</li>
                </ul>
              </div>

              <button
                type="button"
                className="btn btn-success btn-lg"
                onClick={generateExcel}
                disabled={!userConnexions.length}
              >
                <i className="fas fa-file-excel mr-2" />
                {t("generate_the_list")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenerateExcelForUserConnexions;
